import { GET, POST } from "@/services/request";
import * as APIs from '@/services/APIs';

/**
 * 获取预约列表
 */
export const fetchParkingList = async (params) => {
  const res = await GET(APIs.API_SUBSCRIBE_PARKING_LIST, { params });
  return res.data.data ?? {};
};

/**
 * 确认入场
 */
export const fetchCheckIn = async (data) => {
  const res = await POST(APIs.API_SUBSCRIBE_PARKING_CHECKIN, { data });
  return res.data ?? {};
};

/**
 * 撤销入场
 */
export const fetchRevokeIn = async (data) => {
  const res = await POST(APIs.API_SUBSCRIBE_PARKING_REVOKEIN, { data });
  return res.data ?? {};
};

/**
 * 代客泊车详情
 */
export const fetchParkingInfo = async (service_id) => {
  const res = await GET(APIs.API_SERVICE_VALETINFO, { params: { service_id } });

  return res.data.data ?? {};
};

/**
 * 编辑代客泊车
 */
export const fetchEditParking = async (data) => {
  const res = await POST(APIs.API_SERVICE_EDITVALET, { data });

  return res.data.data ?? {};
};